export default __webpack_public_path__ + "static/media/probab.c51e9e03.jfif";